import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-zinc-200 mt-24 bg-zinc-50/60">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="h-7 w-7 grid place-items-center rounded-md surface-navy font-display text-lg">B</div>
            <span className="font-display text-xl">BizzAtlas</span>
          </div>
          <p className="text-sm text-zinc-500 max-w-xs">The global B2B directory connecting buyers with verified service providers in 19 industries.</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-zinc-400 mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><Link to="/categories" className="hover:text-zinc-900">Categories</Link></li>
            <li><Link to="/search" className="hover:text-zinc-900">Search</Link></li>
            <li><Link to="/pricing" className="hover:text-zinc-900">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-zinc-400 mb-3">For business</div>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><Link to="/list-business" className="hover:text-zinc-900">List a business</Link></li>
            <li><Link to="/dashboard" className="hover:text-zinc-900">Dashboard</Link></li>
            <li><Link to="/dashboard/ads" className="hover:text-zinc-900">Advertise</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-zinc-400 mb-3">Company</div>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><Link to="/about" className="hover:text-zinc-900">About</Link></li>
            <li><Link to="/contact" className="hover:text-zinc-900">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-zinc-900">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-zinc-900">Privacy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-4 flex items-center justify-between text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} BizzAtlas, Inc.</span>
          <span className="font-mono-tag">v1 · By Interact Design</span>
        </div>
      </div>
    </footer>
  );
}
